import { ThemeOptions } from '@material-ui/core';
import logo from './assets/img/logo.svg';
import favicon from './assets/img/favicon.ico';
import appleIcon from './assets/img/icon-256x256.png';
import manifest from './manifest.webmanifest';

export const overrides: ThemeOptions = {
  palette: {
    type: 'dark',
    primary: {
      main: '#8F150A',
    },
  },
  meta: {
    propertyName: 'BunkerEx',
    propertyOwner: 'BunkerEx',
    propertyDesc: 'TBC',
    logo,
    favicon,
    manifest,
    appleIcon,
    googAnal: 'UA-206620876-1', // SIMON'S TESTING ACC TRACKING ID
    twitterId: 'bunker_ex',
    policies: [],
    loginTerms: 'NULL',
  },
};

export default overrides;
